import React from "react";
import { AlertCircle, X } from "lucide-react";
import { Dialog, DialogClose, DialogContent } from "./Dialog";
import { Button } from "./Button";

interface DuplicateYouTubeVideoAlertProps {
    open: boolean;
    onClose: () => void;
}

const DuplicateYouTubeVideoAlert: React.FC<DuplicateYouTubeVideoAlertProps> = ({
    open,
    onClose,
}) => (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
        <DialogContent className="max-w-sm p-6 flex flex-col items-center gap-4 text-center bg-white">
            <DialogClose className="absolute top-4 right-4 text-gray-400 hover:text-gray-600">
                <X className="h-4 w-4" />
            </DialogClose>
            <AlertCircle className="h-10 w-10 text-yellow-500" />
            <p className="text-sm text-gray-800">
                This video has already been used for a YouTube post. Please select a different video.
            </p>
            <Button
                className="bg-primary text-primary-foreground hover:bg-primary/90"
                onClick={onClose}
            >
                Close
            </Button>
        </DialogContent>
    </Dialog>
);

export default DuplicateYouTubeVideoAlert;
